import { render } from "./submission-tab-questions.vue?vue&type=template&id=8e1df2ea&scoped=true&ts=true"
import script from "./submission-tab-questions.vue?vue&type=script&lang=ts"
export * from "./submission-tab-questions.vue?vue&type=script&lang=ts"

import "./submission-tab-questions.vue?vue&type=style&index=0&id=8e1df2ea&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e1df2ea"]])

export default __exports__